import {useState, useEffect} from '@wordpress/element';
import classNames from "classnames";

const FontSizeAdjuster = () => {
  const defaultFontSize = 10;
  const maxFontSize = 16;
  const minFontSize = 7;

  const [fontSize, setFontSize] = useState(() => {
    const savedFontSize = localStorage.getItem('fontSize');
    return savedFontSize ? parseInt(savedFontSize, 10) : defaultFontSize;
  });

  useEffect(() => {
    document.documentElement.style.setProperty('--base-font-size', `${fontSize}px`);
    localStorage.setItem('fontSize', fontSize);
  }, [fontSize]);

  const increaseFontSize = () => {
    setFontSize(prevSize => Math.min(maxFontSize, prevSize + 2));
  };

  const decreaseFontSize = () => {
    setFontSize(prevSize => Math.max(minFontSize, prevSize - 2));
  };

  const resetFontSize = () => {
    setFontSize(defaultFontSize);
  };

  const handleKeyDown = (event) => {
    // Mac: ⌘ + 0, ⌘ + +, ⌘ + -
    // Windows/Linux: Ctrl + 0, Ctrl + +, Ctrl + -
    if ((event.ctrlKey || event.metaKey) && event.key === '0') {
      resetFontSize();
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <div className={classNames('font-size-adjuster')}>
      <button onClick={decreaseFontSize} className="p-2 mb-0" disabled={fontSize <= minFontSize}>
        <svg className="icon-image">
          <use href={`#assets--icons--zoom-out`}/>
        </svg>
        <span className={classNames('fn-label')}>kleiner</span>
      </button>
      {/*<button onClick={resetFontSize} className="p-2" disabled={fontSize === defaultFontSize}>Reset</button>*/}
      <button onClick={increaseFontSize} className="p-2 mb-0" disabled={fontSize >= maxFontSize}>
        <svg className="icon-image">
          <use href={`#assets--icons--zoom-in`}/>
        </svg>
        <span className={classNames('fn-label')}>größer</span>
      </button>
    </div>
  );
};

export default FontSizeAdjuster;
